/**
 * Visx implementations of the Chart interface.
 *
 * Bar + Pie/Donut land Week 2; line/area + stacked Week 3; geo + sparkline-
 * table + KPI Week 4. Visx is the geo backbone for the Option B fallback —
 * Recharts delegates geo rendering here.
 */

import type { FullChartProps } from '../types';
import { VisxBar } from './Bar';
import { VisxPie } from './Pie';
import { VisxGeo } from './Geo';

export function renderVisxChart(props: FullChartProps): JSX.Element {
  switch (props.type) {
    case 'bar':
      return <VisxBar {...props} />;
    case 'pie':
    case 'donut':
      return <VisxPie {...props} />;
    case 'geo':
      return <VisxGeo {...props} />;
    default:
      throw new Error(
        `Visx implementation for chart type '${props.type}' not yet wired. Land in Week 3 (line/area/stacked) or Week 4 (sparkline-table/kpi).`
      );
  }
}
